<template>
  <div class="uploadGrade">
    <Breadcrumb></Breadcrumb>
    <div class="mySteps">
      <span><i v-if="active-0<=1" :class="{current:active==1}">1</i><i  v-else class="el-icon-check success"></i>上传excel</span>
      <div class="line"></div>
      <span><i v-if="active-0<=2" :class="{current:active==2}">2</i><i  v-else class="el-icon-check success"></i>匹配成绩单</span>
      <div class="line"></div>
      <span><i v-if="active-0<=3" :class="{current:active==3}">3</i><i  v-else class="el-icon-check success"></i>生成成绩单</span>
    </div>
    <firstStep v-if="active==1" :obj="obj" :list="list" />
    <secondStep v-if="active==2&&type==1" :obj="obj" :list="list" />
    <secondStepType v-if="active==2&&type==2" :obj="obj" :list="list2"/>
    <thirdStep v-if="active==3&&type==1" :obj="obj" />
    <thirdStepType v-if="active==3&&type==2" :obj="obj" />
  </div>
</template>

<script>
import {} from "@/api/common_api";
// import { DatePicker,Select } from "element-ui";
import moment from "dayjs";
import { Breadcrumb } from "@/components";
import firstStep from "./module/firstStep"
import secondStep from "./module/secondStep"
import secondStepType from "./module/secondStepType"
import thirdStep from "./module/thirdStep"
import thirdStepType from "./module/thirdStepType"

export default {
  components: {
    Breadcrumb,
    firstStep,
    secondStep,
    thirdStep,
    secondStepType,
    thirdStepType
  },
  data() {
    return {
      active:1,
      obj:{
        files:'',
        type:'"xlsx"',
        index:1,
        queryName:'',
        subjectName:'',
        customName:'',
        origName:''
      },
      tableHead:{
        code:'',
        name:'',
        totalPoints:''
      },
      transcriptId:'',
      type:this.$route.query.type,
      // type:1,
      list:[],
      list2:[]
    };
  },
  created() {
    
  },
  computed: {
    getText() {}
  },
  methods:{
    setActive(val){
      this.active = val
    }
  },
  beforeDestroy(){
    
  }
};
</script>

<style lang="less" scoped>
.uploadGrade{
  background: #ffffff;
  padding: 0 14Px;
  min-height: 1000Px;
  .mySteps{
    margin-top: 29Px;
    font-size: 14Px;
    color: #444;
    padding: 0 40Px;
    span{
      margin: 0 10Px;
      i{
        display: inline-block;
        width: 32Px;
        height: 32Px;
        border-radius: 50%;
        background: #C6C6C6;
        vertical-align: middle;
        margin-right: 10Px;
        color: #fff;
        line-height: 32Px;
        text-align: center;
        font-size: 16Px;
        &.success{
          background: #63B4FF;
        }
        &.current{
          background: #1890FF;
        }
      }
    }
    .line{
      width: 160Px;
      border-bottom: 1px dashed #979797;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

</style>
